/**
 * The `user` and `impersonatingUser` session cookies (owner, 2 Nov 2026).
 *
 * useCookie already JSON encodes its value, so the user is handed over as an OBJECT:
 * it used to be JSON.stringify(user), encoded a second time, every quote going out as
 * %5C%22. And it carries no access token: the token has its own `accessToken` cookie
 * (and `impersonatingAccessToken`), which is where every reader gets it. Together that
 * kept an admin of 5+ clubs over the browser's 4 KB cookie limit: the cookie was
 * dropped and every full page load read as signed out.
 *
 * Reading accepts what the previous build wrote (a JSON string inside the cookie), so
 * nobody is signed out by the release. Pure, imported explicitly.
 */

/** What the cookie stores: the user without its access token, or null. */
export function userForCookie(user) {
  if (!user || typeof user !== 'object') return null;
  const {accessToken, ...rest} = user;
  return rest;
}

/** The user from the cookie's decoded value: an object, or the old JSON string. Anything else is no user. */
export function userFromCookie(value) {
  if (value && typeof value === 'object' && !Array.isArray(value)) return value;
  if (typeof value !== 'string' || value.trim() === '') return null;
  try {
    const parsed = JSON.parse(value);
    return parsed && typeof parsed === 'object' && !Array.isArray(parsed) ? parsed : null;
  } catch {
    return null;
  }
}
